/**
 * Body editor for the combine_or step: create-vs-into-existing target
 * toggle, target name (free input or existing-field slot), and the drop
 * zone for the answer options OR'd together.
 */
import React from "react"
import { Radio } from "antd"
import type { RadioChangeEvent } from "antd"
import BuilderDropZone from "../../../Builder/BuilderDropZone.component"
import { QueryBuilderStore } from "stores/queryBuilderStore"
import { CombineOrStep } from "types/queryBuilder.types"
import SingleFieldSlot from "../SingleFieldSlot.component"
import { StepBodyProps } from "./stepBodyProps"

export interface CombineOrStepBodyProps extends StepBodyProps<CombineOrStep> {
  renameStep: QueryBuilderStore["renameTransformStep"]
  setMode: QueryBuilderStore["setStepMode"]
  onAddSource: (variable: string) => void
  onRemoveSource: (variable: string) => void
}

const CombineOrStepBody: React.FC<CombineOrStepBodyProps> = ({
  step,
  renameStep,
  setMode,
  onAddSource,
  onRemoveSource,
}) => (
  <>
    <div className="qc-step__field-row">
      <span className="qc-step__field-label">Target:</span>
      <Radio.Group
        value={step.mode}
        onChange={(e: RadioChangeEvent) => setMode(step.id, e.target.value)}
        size="small"
      >
        <Radio.Button value="create">Create new field</Radio.Button>
        <Radio.Button value="into_existing">OR into existing</Radio.Button>
      </Radio.Group>
    </div>
    {step.mode === "create" ? (
      <input
        className="qc-recodes__name qc-mono"
        type="text"
        value={step.name}
        onChange={(e) => renameStep(step.id, e.target.value)}
        placeholder="New variable name (use // for nesting)"
        aria-label="Variable name"
      />
    ) : (
      <div className="qc-step__field-row">
        <span className="qc-step__field-label">Existing field:</span>
        <SingleFieldSlot
          value={step.name}
          onChange={(v) => renameStep(step.id, v)}
          placeholder="Drag the existing field to OR into"
        />
      </div>
    )}
    <BuilderDropZone
      label="Source answer options"
      variables={step.sources}
      onAdd={onAddSource}
      onRemove={onRemoveSource}
      emptyHint="Drag answer options that should belong to this group"
      expandParents
    />
  </>
)

export default CombineOrStepBody
